import { createApp } from 'vue'

import './css/style.css'
import App from './App.vue'
import router from './router'
import directives from './directives'
import config from '@/plugins/config'
import VueTheMask from 'vue-the-mask'

async function bootstrap() {
  const app = createApp(App)

  app.use(router).use(directives).use(config).use(VueTheMask)

  await app.loadConfig()

  app.mount('#app')
}

bootstrap()
